var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"separator",style:({ margin: `${_vm.marginTop}px 0px ${_vm.marginBottom}px`, borderTop: `0.5px solid ${_vm.color}`})})
}
var staticRenderFns = []

export { render, staticRenderFns }